import type { EntityConfig } from '../types'

export const tariffEntity: EntityConfig = {
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'draft', label: 'Draft' },
      { value: 'archived', label: 'Archived' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
      { value: 'draft', label: 'Draft', color: 'neutral' },
      { value: 'archived', label: 'Archived', color: 'warning' },
    ],
    mappings: {
      active: ['active'],
      inactive: ['inactive'],
      draft: ['draft'],
      archived: ['archived'],
    },
  },
  queryFields: {
    status: { type: 'status', label: 'Status' },
    merchantType: { type: 'select', label: 'Merchant Type' },
    region: { type: 'text', label: 'Region' },
    effectiveDate: { type: 'date', label: 'Effective Date' },
  },
  uiFilterFields: ['status', 'merchantType', 'region'],
}
